export default __webpack_public_path__ + "5293cb560a8ad721de6ae4e3987f85ca.svg";